import React, { useEffect, useState } from 'react';
import { Box, Chip, CircularProgress, Typography, Grid, Button, Tooltip, IconButton } from '@mui/material';
import api from '../../../conf/api'; // Adjust your API import
import { toast } from 'react-toastify';
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline';
import { useLocation, useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import UserAutoComplete from '../../../Components/AutoCompletes/UserAutoComplete';

const Library = (props) => {
    const location = useLocation();
    const navigate = useNavigate();

    const getInitialParams = () => {
        const searchParams = new URLSearchParams(location.search);
        return {
            approved: true,
            categories: searchParams.get('categories') || '',
            // page: parseInt(searchParams.get('page'), 1) || 1,
            page_size: parseInt(searchParams.get('page_size'), 1000) || 1000,
            downloaded: searchParams.get('downloaded') === 'true',
        };
    };

    const [user, setUser] = useState(null);
    const [categories, setCategories] = useState([]);
    const [selected, setSelected] = useState([]);
    const [loading, setLoading] = useState(false);
    const [videos, setVideos] = useState([]);
    const [videoLoading, setVideoLoading] = useState(false);
    const [params, setParams] = useState(getInitialParams);

    useEffect(() => {
        const fetchCategories = async () => {
            setLoading(true);
            try {
                const response = await api.get('/users/categories/');
                setCategories(response.data);
            } catch (err) {
                console.error('Failed to fetch categories:', err);
            }
            setLoading(false);
        };

        fetchCategories();
    }, []);

    useEffect(() => {
        const FetchVideos = async () => {

            setVideoLoading(true);
            const _params = { ...params };
            if (user?.username) {
                _params["user"] = user.username;
            }
            try {
                const response = await api.get('/videos/api/', {
                    params: _params,
                });
                setVideos(response.data?.results);
            } catch (err) {
                console.error('Failed to fetch videos:', err);
            }
            setVideoLoading(false);

        };

        if ((selected.length > 0 && params.categories) || params.downloaded) {
            FetchVideos();
        } else {
            setVideos([]);
        }

    }, [user, selected]);

    useEffect(() => {
        const searchParams = new URLSearchParams();
        Object.entries(params).forEach(([key, value]) => {
            if (value !== undefined && value !== null) {
                searchParams.set(key, value);
            }
        });
        navigate({ search: searchParams.toString() }, { replace: true });
    }, [params, navigate]);

    useEffect(() => {
        const updateParamsFromURL = () => {
            const searchParams = new URLSearchParams(location.search);
            const ctgs = searchParams.get('categories') || null;
            if (ctgs) {
                const selectedCategories = ctgs.split(',').map(Number);
                setSelected(selectedCategories);
            } else {
                setSelected([]);
            }
            setParams({
                approved: true,
                categories: searchParams.get('categories') || '',
                // page: parseInt(searchParams.get('page'), 10) || 1,
                page_size: parseInt(searchParams.get('page_size'), 1000) || 1000,
                downloaded: searchParams.get('downloaded') === 'true',
            });
        };

        updateParamsFromURL();
    }, [location.search]);


    const handleChipToggle = (categoryId) => {
        const updatedSelected = selected.includes(categoryId)
            ? selected.filter((id) => id !== categoryId)
            : [...selected, categoryId];
        setSelected(updatedSelected);
        setParams(pre => ({ ...pre, categories: updatedSelected.join(','), downloaded: false }));
    };
    const FetchVideo = async () => {

        setVideoLoading(true);
        const _params = { ...params };
        if (user?.username) {
            _params["user"] = user.username;
        }
        try {
            const response = await api.get('/videos/api/', {
                params: _params,
            });
            setVideos(response.data?.results);
        } catch (err) {
            console.error('Failed to fetch videos:', err);
        }
        setVideoLoading(false);

    };

    const handleDownload = (video) => async () => {
        const download_link = video.dropbox_link?.replace("www.dropbox.com", "dl.dropboxusercontent.com");

        try {
            // Ask user where to save the file
            const fileHandle = await window.showSaveFilePicker({
                suggestedName: video.title || "video.mp4",
                types: [
                    {
                        description: "MP4 Video",
                        accept: { "video/mp4": [".mp4"] },
                    },
                ],
            });

            const writable = await fileHandle.createWritable();

            // Send request to save download history
            try {
                const res = await api.post("videos/downloads-history/", { video: video.id });
                if (res.status === 201) {
                    const blob = await fetch(download_link).then(res => res.blob());
                    await writable.write(blob);
                    await writable.close();
                    toast.success('Download completed!');
                    FetchVideo();
                }
            } catch (err) {
                if (err.response?.status === 400 && err.response?.data?.non_field_errors) {
                    const blob = await fetch(download_link).then(res => res.blob());
                    await writable.write(blob);
                    await writable.close();
                    toast.info('Downloading... again.');
                    FetchVideo();
                } else {
                    await writable.close();
                    toast.error('Failed to start download.');
                    console.error('Error:', err);
                }
            }
        } catch (dialogError) {
            console.warn("Save dialog was canceled or failed:", dialogError);
        }
    };


    return (
        <Box p={3}>
            <Box maxWidth={300} mb={2}>
                <UserAutoComplete
                    params={{ is_creator: true, has_categoires: true, page_size: 1000 }}
                    onChange={_user => {
                        setUser(_user);
                    }}
                    user={user}
                    selectUserObj
                />

            </Box>
            {!params.downloaded &&
                <Typography variant="h5" gutterBottom>
                    Select Categories
                </Typography>
            }

            {loading ? (
                <CircularProgress />
            ) : (
                !params.downloaded && (
                    <Grid container spacing={2}>
                        {categories.map((cat) => (
                            <Grid item key={cat.id}>
                                <Chip
                                    sx={{ minWidth: 100 }}
                                    label={cat.name}
                                    clickable
                                    onClick={() => handleChipToggle(cat.id)}
                                    color={selected.includes(cat.id) ? 'primary' : 'default'}
                                    variant={selected.includes(cat.id) ? 'filled' : 'outlined'}
                                />
                            </Grid>
                        ))}
                    </Grid>
                )
            )}

            <Box mt={4}>
                <Typography variant="h6" gutterBottom>
                    {params.downloaded ? "Downloaded Video" : "Videos"}
                </Typography>

                {videoLoading ? (
                    <CircularProgress />
                ) : videos.length > 0 ? (
                    <Grid container spacing={2}>
                        {videos.map((video) => (
                            <Grid item xs={12} sm={6} md={4} xl={3} key={video.id}>
                                <Box border={1} borderRadius={2} p={2} height="100%" minHeight={{ xs: 370, md: 400 }}>
                                    {props.is_admin &&
                                        <Typography variant="caption" >
                                            Downloaded By: {video.downloads?.map(u => u.user_email + ", ")}
                                        </Typography>
                                    }
                                    <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                                        {video.assert_id}
                                    </Typography>
                                    <Typography variant="subtitle2" noWrap gutterBottom>
                                        {video.title}
                                    </Typography>
                                    <Typography variant="body2" color="textSecondary" gutterBottom>
                                        Uploaded by: {`${video.username}`}
                                        <br />
                                        ({video.user})
                                    </Typography>
                                    <Box
                                        component="video"
                                        width="100%"
                                        controls
                                        src={video.dropbox_link?.replace("www.dropbox.com", "dl.dropboxusercontent.com")}
                                        sx={{ marginBottom: '8px', height: { xs: "auto", sm: 150, md: 300 }, background: "#000" }}
                                    />
                                    <Button
                                        variant={!params.downloaded ? "contained" : "varient"}
                                        color='success'
                                        endIcon={<DownloadForOfflineIcon color={params.downloaded ? 'success' : "inherit"} />}
                                        onClick={handleDownload(video)}
                                    >
                                        Download
                                    </Button>
                                </Box>
                            </Grid>
                        ))}
                    </Grid>
                ) : (
                    <Typography>No videos available for the selected categories.</Typography>
                )}
            </Box>
        </Box>
    );
};
const mapStatesToProps = (state) => {
    return {
        is_admin: state.user?.is_staff,
    };
};

export default connect(mapStatesToProps, null)(Library);

